<template>
	<div>
		<page-title-bar></page-title-bar>
		<v-container fluid grid-list-xl pt-0>
			<v-layout row wrap>
				<app-card :fullBlock="true" colClasses="xs12">
					<v-card-title>
						<v-btn @click.stop="onAdd" color="primary" outline>
							<i class="material-icons">add</i>
							{{ $t("message.addNew") }}
						</v-btn>
						<manage-product
							:dialog.sync="showModal"
							:isEdit.sync="isEdit"
							:isCreate.sync="isCreate"
							@close-dialog="showModal = false"
							@on-save="onSave"
							ref="manageProductModal"
						></manage-product>
						<image-manage
							:dialog.sync="showModalImage"
							ref="imageManage"
						></image-manage>
						<v-spacer></v-spacer>
						<v-text-field
							append-icon="search"
							hide-details
							:label="$t('message.search')"
							single-line
							v-model="search"
						></v-text-field>
					</v-card-title>

					<v-data-table :headers="headers" :items="products" :search="search">
						<template slot="headerCell" slot-scope="props">
							<v-tooltip bottom>
								<span slot="activator">{{
									$t(`message.${props.header.text}`)
								}}</span>
								<span>{{ $t(`message.${props.header.text}`) }}</span>
							</v-tooltip>
						</template>
						<template slot="items" slot-scope="props">
							<td>{{ props.item.name }}</td>
							<td>{{ props.item.description | shortDescription }}</td>
							<td>{{ props.item.price }}</td>
							<td>{{ props.item.catalogueName }}</td>
							<td>{{ props.item.quantity }}</td>
							<td class="text-left">
								<v-tooltip top>
									<v-btn
										@click="onEdit(props.item)"
										color="primary"
										outline
										fab
										icon
										small
										slot="activator"
									>
										<v-icon light>zmdi-edit</v-icon>
									</v-btn>
									<span>{{ $t("message.edit") }}</span>
								</v-tooltip>
								<v-tooltip top>
									<v-btn
										@click="onAddImage(props.item)"
										class="trash-icon"
										color="amber"
										outline
										fab
										icon
										slot="activator"
										small
									>
										<v-icon light>zmdi-collection-image-o</v-icon>
									</v-btn>
									<span>{{ $t("message.addImage") }}</span>
								</v-tooltip>
								<v-tooltip top>
									<v-btn
										@click="goTo(props.item)"
										class="trash-icon"
										color="blue"
										outline
										fab
										icon
										slot="activator"
										small
									>
										<v-icon light>zmdi-share</v-icon>
									</v-btn>
									<span>{{ $t("message.share") }}</span>
								</v-tooltip>
								<v-tooltip top>
									<v-btn
										@click="sendPromo(props.item)"
										class="white--text"
										color="success"
										outline
										fab
										icon
										slot="activator"
										small
									>
										<v-icon>zmdi-mail-send</v-icon>
									</v-btn>
									<span>{{ $t("message.sendPromo") }}</span>
								</v-tooltip>
								<v-tooltip top>
									<v-btn
										@click="sendPromo(props.item, true)"
										color="#262261"
										outline
										fab
										icon
										slot="activator"
										small
									>
										<v-icon>zmdi-mail-send</v-icon>
									</v-btn>
									<span>Enviar Promoción Web</span>
								</v-tooltip>
								<v-tooltip top>
									<v-btn
										@click="onDelete(props.item)"
										class="trash-icon"
										color="error"
										outline
										fab
										icon
										slot="activator"
										small
									>
										<v-icon light>cancel</v-icon>
									</v-btn>
									<span>{{ $t("message.delete") }}</span>
								</v-tooltip>
							</td>
						</template>
					</v-data-table>
					<delete-confirmation-dialog
						@onConfirm="deleteProduct"
						:heading="$t('message.deleteConfirmation')"
						:message="$t('message.deleteMessage')"
						ref="deleteConfirmationDialog"
					></delete-confirmation-dialog>
				</app-card>
			</v-layout>
		</v-container>
	</div>
</template>

<script>
import { mapGetters } from "vuex";
import ManageProduct from "./ManageProduct";
import ImageManage from "./ImageManage";
import {
	DELETE_PRODUCT,
	GET_PRODUCTS,
	CREATE_PRODUCT,
	UPDATE_PRODUCT,
	GET_IMAGES_PRODUCT,
} from "../../store/modules/products/actions.type";
import { SEND_PROMO } from "../../store/modules/telegramBot/actions.type";

export default {
	name: "productList",
	components: {
		ManageProduct,
		ImageManage,
	},
	filters: {
		shortDescription(value) {
			return value.slice(0, 40) + "...";
		},
	},
	data() {
		return {
			headers: [
				{ text: "name", sortable: true, value: "name" },
				{ text: "description", sortable: true, value: "description" },
				{ text: "price", sortable: true, value: "price" },
				{ text: "catalogue", sortable: true, value: "catalogueName" },
				{ text: "quantity", sortable: true, value: "quantity" },
				{ text: "actions", sortable: false, value: "" },
			],
			search: "",
			showModal: false,
			showModalImage: false,
			isCreate: true,
			isEdit: false,
			selectedProduct: {},
			pagination: {},
		};
	},
	computed: {
		...mapGetters([
			"loadingProduct",
			"products",
			"sendingMessage",
			"imagesProduct",
		]),
		store() {
			return this.$store.getters.store.web_store;
		},
	},
	created() {
		this.getProducts();
	},
	methods: {
		goTo({ web_url }) {
			console.log(web_url);
			const url = `${process.env.VUE_APP_WEB_STORE_URL}/${this.store}/${web_url}`;
			window.open(url, "_blank");
		},
		deleteProduct() {
			this.$store.dispatch(DELETE_PRODUCT, this.selectedProduct.id);
			this.$refs.deleteConfirmationDialog.close();
		},
		getProducts() {
			this.$store.dispatch(GET_PRODUCTS);
		},
		onAdd() {
			this.showModal = true;
			this.isCreate = true;
			this.isEdit = false;
		},
		onAddImage(product) {
			this.showModalImage = true;
			this.selectedProduct = product;
			this.$refs.imageManage.setValue(product);
		},
		onDelete(product) {
			this.selectedProduct = product;
			this.$refs.deleteConfirmationDialog.openDialog();
		},
		onEdit(product) {
			this.$store.dispatch(GET_IMAGES_PRODUCT, product.id);
			//const { full_url_image } = this.imagesProduct[0]
			this.showModal = true;
			this.isCreate = false;
			this.isEdit = true;
			this.selectedProduct = product;
			this.$refs.manageProductModal.setValue(product);
		},
		async onSave(product) {
			if (this.isCreate) {
				await this.$store.dispatch(CREATE_PRODUCT, product);
			} else {
				this.selectedProduct = Object.assign({}, this.selectedProduct, product);
				await this.$store.dispatch(UPDATE_PRODUCT, this.selectedProduct);
			}

			this.$refs.manageProductModal.clearForm();
		},
		sendPromo(product, web = false) {
			this.$store.dispatch(SEND_PROMO, {
				productId: product.id,
				text: product.description,
				web,
				storeId: this.$store.getters.store.id,
			});
		},
	},
};
</script>

<style></style>
